import { createSelector } from "reselect";
import {
  genericSelector,
  userDetailsSelector,
  currentPhoneNumberSelector
} from "ducks/selectors";
import get from "lodash/get";
import { splitJapaneseName } from "utils/helpers";

/**
 * Returns reverse portin form values state
 * @param {object} state redux state
 */
const reversePortInDomain = state =>
  get(state, "form.ReversePortInForm.values");

export const reversePortinSelector = createSelector(
  reversePortInDomain,
  portout => portout
);

/**
 * Returns reverse portin form values
 */
export const makeSelectReversePortInForm = () => reversePortinSelector;
/**
 * Returns initial values for reverse portin form
 */
export const makeSelectReversePortInFormInitialValues = () =>
  createSelector(
    genericSelector,
    userDetailsSelector,
    currentPhoneNumberSelector,
    (generic, userDetails, contact_number) => {
      const country_code = get(generic, "contact_number.prefix");
      const first_name =
        get(userDetails, "telco_info.first_name", "") ||
        get(userDetails, "telco_info.kanji_name", "");
      const last_name =
        get(userDetails, "telco_info.last_name", "") ||
        get(userDetails, "telco_info.katakana_name", "");
      const [last_name_kanji, first_name_kanji] = splitJapaneseName(first_name);
      const [last_name_katakana, first_name_katakana] = splitJapaneseName(
        last_name
      );

      const initialValues = {
        first_name,
        last_name,
        last_name_kanji,
        first_name_kanji,
        last_name_katakana,
        first_name_katakana,
        country_code,
        contact_number
      };

      return initialValues;
    }
  );
